import { render } from "./FieldBoolean.vue?vue&type=template&id=6812df22"
import script from "./FieldBoolean.vue?vue&type=script&lang=js"
export * from "./FieldBoolean.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__